// extracted by mini-css-extract-plugin
module.exports = {"layout":"StickyHeader_layout__2GvkB"};